import { render, staticRenderFns } from "./FieldWorkplaceTableEmployee.vue?vue&type=template&id=08ba5474&scoped=true"
import script from "./FieldWorkplaceTableEmployee.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceTableEmployee.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceTableEmployee.vue?vue&type=style&index=0&id=08ba5474&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba5474",
  null
  
)

export default component.exports